import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>SussyPicious Image Yes</h1>
      <h2>Pictures</h2>
      <p>Click the Button to add a New Sussy Image. Click the Image to View the Full Image</p>
    </div>
  )
}

export default Title;